// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Ouox","paramInput":"JobSimulator_paramInput__2BqXS","input":"JobSimulator_input__1j4IL"};